import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_AGE007_Request,
  IAPI_AGE007_Response,
} from "../../../type/apiType";
import {
  IAPI_AGE010_Request,
  IAPI_AGE010_Response,
} from "../../../type/apiType";

// 代行入力依頼参照API
const httpAPI_AGE007 = async (
  param: IAPI_AGE007_Request
): Promise<IAPI_AGE007_Response> => {
  let res = await http.post(ApiUrl.API_AGE007, {
    ...param,
  });
  return res.data;
};

// 代行入力完了更新API
const httpAPI_AGE010 = async (
  param: IAPI_AGE010_Request
): Promise<IAPI_AGE010_Response> => {
  let res = await http.post(ApiUrl.API_AGE010, {
    ...param,
  });
  return res.data;
};

export { httpAPI_AGE010, httpAPI_AGE007 };
